import { call, take, put } from 'redux-saga/effects';
import { SUBMIT_FORM }     from '../actions';
import axios               from 'axios';

const endpoint = 'api/submitForm.php';

function* submitForm() {
  while(true) {
    try {

        const userInput = yield take('SUBMIT_FORM_SAGA');

        if (process.env.NODE_ENV === 'development') {

            console.log('userInput.payload   :  ',userInput.payload)
            yield put(SUBMIT_FORM(1))

            return
        }

        const {  userId, quizName, userName, userEmail, schoolName, city, teacherName, allowNotifications, arabic } = userInput.payload;

        console.log('userInput.payload   :  ',userInput.payload)

        
        const response = yield call( 
          axios.post, 
          endpoint, 
          { 
            userId:             userId,
            quizName:           quizName,
            userName:           userName,
            userEmail:          userEmail,
            schoolName:         schoolName,
            city:               city,
            teacherName:        teacherName,
            allowNotifications: allowNotifications,
            arabic:             arabic
          }
        ) 

        console.log('response       :   ',response);
        console.log('response.data  :   ',response.data);

        if (response.data) {
            yield put(SUBMIT_FORM(response.data.success))
        }
        else {
          console.log('no response - cannot submit form')
        }
      
    }
    catch(err) {
      yield put(SUBMIT_FORM(0))
      console.log('err  :  '+err);

    }
    finally {}
  }
}


export default submitForm;
